export default "__VITE_ASSET__RJwQ_9Q7__"